import React, {useEffect, useState} from "react";
import styled from "styled-components";
import T from "../services/language";
import {getSettings} from "../services/app";
import Loading from "../components/Loading";

// Create context maintainer
const Maintain = React.createContext({});

interface MaintainProviderProps {
    children?: any;
}

// Export context maintainer
export const MaintainProvider = (props: MaintainProviderProps) => {
    const [mode, setMode] = useState<string | null>();

    useEffect(() => {
        document.querySelector('#loading')?.remove?.();
        loadSetting().then();
        // @ts-ignore
        window.setMaintenance = () => {
            setMode('maintenance');
        }
    }, []);

    const loadSetting = async () => {
        const result = await getSettings();
        if (result.status === 200) {
            const data = result?.data?.data
            setMode(data?.mode);
        }else {
            setMode('error');
        }
    }

    return !!mode ? (
        <Maintain.Provider value={{}}>{
            mode === 'maintenance' ? (
                <Container>
                    <Image src="/assets/images/maintain-bg.png"/>
                    <Title>{T("Maintenance in Progress. Please comeback later")}</Title>
                </Container>
            ) : props.children
        }</Maintain.Provider>
    ) : (
        <Container>
            <Loading/>
        </Container>
    );
}


const Container = styled.div`
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    height: 100vh;
`;

const Image = styled.img`
    width: 580px;
    aspect-ratio: 29/20;
    margin-bottom: 48px;
    max-width: 80%;
    height: auto;
    object-fit: contain;

    @media screen and (max-width: 550px) {
        width: 80%;
        height: auto;
        margin-bottom: 24px;
    }
`;

const Title = styled.div`
    color: #494949;
    text-align: center;
    font-size: 32px;
    font-weight: 600;
    line-height: 48px;
    width: 580px;

    @media screen and (max-width: 550px) {
        width: 80%;
        height: auto;
        font-size: 24px;
        line-height: 32px;
    }
`;